import { render, staticRenderFns } from "./Alipay.vue?vue&type=template&id=cd63696e&scoped=true&"
import script from "./Alipay.vue?vue&type=script&lang=js&"
export * from "./Alipay.vue?vue&type=script&lang=js&"
import style0 from "./Alipay.vue?vue&type=style&index=0&id=cd63696e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd63696e",
  null
  
)

export default component.exports